export default "__VITE_ASSET__DYOp3XzP__"